import { Button, Layout, message, Modal, Space, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllContactus } from '../../redux/actions/AllActions';
import { deleteContact } from '../../api/contactus';
import { Content } from 'antd/es/layout/layout';
import Filter from '../../components/Filter/Filter';
import Loading from '../../components/Loading/Loading';
import ContactDetails from '../Details/ContactDetails';

const ContactUs = () => {
    const dispatch = useDispatch();
    const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const { data, loading } = useSelector((state) => state.data);

    const [filteredItems, setFilteredItems] = useState([]);
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: "300"
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: "300"
        },
        // {
        //     title: "Phone Number",
        //     dataIndex: "phoneNumber",
        //     key: "phoneNumber",
        //     width: "300"
        // },

        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            width: "300"
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => new Date(text).toLocaleString(),
        },
        
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "200px"
                            }}
                        >
                           
                            <Button type="link" onClick={() => handleDetails(record)}>
                                Details
                            </Button>
                            <Button type="link" danger onClick={() => handleDelete(record)}>
                                Delete
                            </Button>

                        </div>
                    }     </Space>
            ),
            fixed: 'right'
        },
    ]
    const handleDelete = (record) => {

        Modal.confirm({
            title: 'Are you sure you want to delete this contact us details?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const resp = await (deleteContact(record._id));
                    if (resp) {
                        dispatch(getAllContactus());
                        message.success('User deleted successfully.');
                    } else {
                        message.error('Failed to delete user');
                    }
                } catch (error) {
                    message.error('An error occurred while deleting the user');
                }
            },
        });



    };

    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };



        useEffect(() => {
            dispatch(getAllContactus());
        }, [dispatch]);
      useEffect(() => {
                setFilteredItems(data);
            }, [data]);

    return (
        <div>
            <Layout            >
                {
                    loading ?
                        <Loading /> :
                        <>

                            <Filter
                                allData={data}
                                setFilteredItems={setFilteredItems}
                                searchKeys={['name', 'email', 'message']}
                            />
                            <Layout>
                                <Content>
                                    <div style={{ overflowX: 'auto', width: '100%' }}>
                                        <Table
                                            columns={columns}
                                            pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                                            dataSource={filteredItems}
                                            rowKey={(record) => record._id}
                                            style={{ height: '68vh' }}
                                            scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                                        />
                                    </div>
                                </Content>
                                
                                <Modal
                                    title="Contact Details"
                                    open={handleDetailsVisible}
                                    onCancel={() => setHandleDetailsVisible(false)}
                                    footer={null}
                                >
                                    <ContactDetails
                                    contact ={editingRecord}
                                    />
                                </Modal>
                            </Layout>
                        </>
                }

            </Layout>
        </div>
    )
}

export default ContactUs